import React from 'react';

const modifySearchHeader = ({ handleClose, title }) => (
  <div className="modifySearchWrapper">
    <span className="iconArrow mmt-long-arrow-back" onClick={handleClose} /> {title}
  </div>
);
export default modifySearchHeader;
